import Vue from "vue";

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {},
  actions: {
    fetchProvider(ctx, params) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$rf
          .getRequest("CommonRequest")
          .getProvider(params)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    }
  },
};
